import {numberFormat} from "@/utils/helper";

export function segmentTracking(props) {
  // return false;

  if (window.analytics) {
    window.analytics.page();

    //Following chunk is setting page names for page events based on the url, legacy The Inside code

    // const urlParams = props.location.pathname.split('/');
    // switch (urlParams[1]) {
    //   case 'c':
    //     if (urlParams.length == 4) {
    //       window.analytics.page('Category', {
    //         categoryName: urlParams[3]
    //       });
    //     } else if (urlParams.length == 5) {
    //       window.analytics.page('Frame', {
    //         frameName: urlParams[4]
    //       });
    //     }
    //     break;
    //   case 'products':
    //     window.analytics.page('Product', {
    //       sku: urlParams[3]
    //     });
    //     break;
    //   case 'collaborators':
    //     window.analytics.page('Collaborator', {
    //       collabName: urlParams[2]
    //     });
    //     break;
    //   case 'collections':
    //     window.analytics.page('Collection', {
    //       collabName: urlParams[2]
    //     });
    //     break;
    //   case 'cart':
    //     window.analytics.page('Cart');
    //     break;
    //   case 'checkout':
    //     window.analytics.page('Checkout');
    //     break;
    //   default:
    //     window.analytics.page();
    // }
  }
}

export function segmentTrackEvent(eventName, payload) {
  // return false;

  if (!window.analytics) {
    setTimeout(() => {
      segmentTrackEvent(eventName, payload);
    }, 500);
  } else {
    window.analytics.track(eventName, payload);
  }
}

export function segmentIdentifyCall(id, payload) {
  // return false;

  if (!window.analytics) {
    setTimeout(() => {
      segmentIdentifyCall(id, payload);
    }, 500);
  } else {
    window.analytics.identify(id, payload);
  }
}

export function formatSegmentDataForProductClickedEvent(product) {
  const baseUrl = window.location.origin;

  if (!product) {
    return {};
  }

  return {
    product_id: product.id,
    sku: product.sku,
    category:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].category.name
        : null,
    subcategory:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].name
        : null,
    name: product.name,
    fabric: product.fabric ? product.fabric.name : null,
    frame: product.frame ? product.frame.name : null,
    legs: product.leg ? product.leg.name : null,
    orientation:
      product.frame && product.frame.orientation
        ? product.frame.orientation == 1
          ? 'left'
          : 'right'
        : null,
    price: parseFloat(product.price),
    url: `${baseUrl}/products/${product.slug}`
  };
}

export function formatSegmentDataForProductViewedEvent(product) {
  const baseUrl = window.location.origin;

  if (!product) {
    return {};
  }

  return {
    product_id: product.id,
    sku: product.sku,
    category:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].category.name
        : null,
    subcategory:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].name
        : null,
    name: product.name,
    fabric: product.fabric ? product.fabric.name : null,
    frame: product.frame ? product.frame.name : null,
    legs: product.leg ? product.leg.name : null,
    orientation:
      product.frame && product.frame.orientation
        ? product.frame.orientation == 1
          ? 'left'
          : 'right'
        : null,
    price: parseFloat(product.price),
    url: `${baseUrl}/products/${product.slug}`
  };
}

export function formatSegmentDataForProductAddedEvent(product, quantity) {
  const baseUrl = window.location.origin;

  if (!product) {
    return {};
  }

  return {
    product_id: product.id,
    sku: product.sku,
    category:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].category.name
        : null,
    subcategory:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].name
        : null,
    name: product.name,
    fabric: product.fabric ? product.fabric.name : null,
    frame: product.frame ? product.frame.name : null,
    legs: product.leg ? product.leg.name : null,
    orientation:
      product.frame && product.frame.orientation
        ? product.frame.orientation == 1
          ? 'left'
          : 'right'
        : null,
    price: parseFloat(product.price),
    quantity: quantity,
    url: `${baseUrl}/products/${product.slug}`
  };
}

export function formatSegmentDataForProductRemovedEvent(product, quantity) {
  const baseUrl = window.location.origin;

  if (!product) {
    return {};
  }

  return {
    product_id: product.id,
    sku: product.sku,
    category:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].category.name
        : null,
    subcategory:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].name
        : null,
    name: product.name,
    fabric: product.fabric ? product.fabric.name : null,
    frame: product.frame ? product.frame.name : null,
    legs: product.leg ? product.leg.name : null,
    orientation:
      product.frame && product.frame.orientation
        ? product.frame.orientation == 1
          ? 'left'
          : 'right'
        : null,
    price: parseFloat(product.price),
    quantity: quantity,
    url: `${baseUrl}/products/${product.slug}`
  };
}

export function formatSegmentDataForFabricSelectedEvent(
  product,
  previousProduct
) {
  const baseUrl = window.location.origin;

  if (!product) {
    return {};
  }

  return {
    product_id: product.id,
    sku: product.sku,
    category:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].category.name
        : null,
    subcategory:
      product.frame && product.frame.subcategories.length > 0
        ? product.frame.subcategories[0].name
        : null,
    name: product.name,
    old_fabric: previousProduct.fabric ? previousProduct.fabric.name : null,
    new_fabric: product.fabric && product.fabric ? product.fabric.name : null,
    old_material:
      previousProduct.fabric && previousProduct.fabric.material
        ? previousProduct.fabric.material.name
        : null,
    new_material:
      product.fabric && product.fabric.material
        ? product.fabric.material.name
        : null
  };
}

export function formatSegmentDataForCartViewedEvent(data) {
  let productsData = [];
  const baseUrl = window.location.origin;

  data.map(i => {
    const product = i.product;
    if (product) {
      productsData.push({
        product_id: product.id,
        sku: product.sku,
        category:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].category.name
            : null,
        subcategory:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].name
            : null,
        name: product.name,
        fabric: product.fabric ? product.fabric.name : null,
        frame: product.frame ? product.frame.name : null,
        legs: product.leg ? product.leg.name : null,
        orientation:
          product.frame && product.frame.orientation
            ? product.frame.orientation == 1
              ? 'left'
              : 'right'
            : null,
        price: parseFloat(product.price),
        quantity: i.quantity,
        url: `${baseUrl}/products/${product.slug}`
      });
    }
  });

  return {
    products: productsData
  };
}

export function formatSegmentDataForCheckoutStartedEvent(data) {
  let productsData = [];
  let revenue = 0;
  const baseUrl = window.location.origin;

  data.map(i => {
    const product = i.product;
    if (product) {
      revenue += parseFloat(product.price) * parseFloat(i.quantity);
      productsData.push({
        product_id: product.id,
        sku: product.sku,
        category:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].category.name
            : null,
        subcategory:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].name
            : null,
        name: product.name,
        fabric: product.fabric ? product.fabric.name : null,
        frame: product.frame ? product.frame.name : null,
        legs: product.leg ? product.leg.name : null,
        orientation:
          product.frame && product.frame.orientation
            ? product.frame.orientation == 1
              ? 'left'
              : 'right'
            : null,
        price: parseFloat(product.price),
        quantity: parseFloat(i.quantity),
        url: `${baseUrl}/products/${product.slug}`,
        image_url: product.images.length > 0 ? product.images[0]?.path : null
      });
    }
  });

  return {
    revenue: revenue,
    products: productsData
  };
}

export function formatSegmentDataForOrderCompletedEvent(data) {
  let productsData = [];
  let revenue = 0;
  const baseUrl = window.location.origin;

  data.orderProducts.map(i => {
    const product = i.product;

    if (product) {
      revenue += parseFloat(product.price) * parseFloat(i.quantity);
      productsData.push({
        product_id: product.id,
        sku: product.sku,
        category:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].category.name
            : null,
        subcategory:
          product.frame && product.frame.subcategories.length > 0
            ? product.frame.subcategories[0].name
            : null,
        name: product.name,
        fabric: product.fabric ? product.fabric.name : null,
        frame: product.frame ? product.frame.name : null,
        legs: product.leg ? product.leg.name : null,
        orientation:
          product.frame && product.frame.orientation
            ? product.frame.orientation == 1
              ? 'left'
              : 'right'
            : null,
        price: parseFloat(product.price),
        quantity: parseFloat(i.quantity),
        url: `${baseUrl}/products/${product.slug}`
      });
    }
  });

  return {
    order_id: data.id,
    total: parseFloat(data.total),
    revenue: revenue,
    coupon:
      data.discountsRelation.length > 0 ? data.discountsRelation[0].code : null,
    discount: parseFloat(data.discounts),
    tax: parseFloat(data.taxes),
    products: productsData
  };
}

export function formatSegmentDataForCategoryPageFilteredEvent(
  category,
  sort,
  filters,
  data,
  page
) {
  let productsData = [];
  let position = (page - 1) * 60;
  data.map(i => {
    i.featuredProducts.map(featuredProduct => {
      if (featuredProduct) {
        productsData.push({
          product_id: featuredProduct.id,
          sku: featuredProduct.sku,
          category: featuredProduct.category,
          name: featuredProduct.name,
          fabric: featuredProduct.fabric ? featuredProduct.fabric.name : null,
          frame: featuredProduct.frame,
          legs: featuredProduct.leg,
          orientation: featuredProduct.orientation,
          price: parseFloat(featuredProduct.price),
          position: ++position
        });
      }
    });
  });

  return {
    category: category,
    sort: sort,
    filters: filters,
    products: productsData,
    page_number: page
  };
}
